import { type FC } from 'react';

import { useLoadRecentlyUsedTemplates } from 'src/services/templates/useLoadRecentlyUsedTemplates';

import { NewProjectWidget, type NewProjectWidgetProps } from './NewProjectWidget';

export const Container: FC<NewProjectWidgetProps> = (props) => {
  useLoadRecentlyUsedTemplates();

  return <NewProjectWidget {...props} />;
};
